import { RoleBasedComponent } from '@/utils/RoleBasedComponent';

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {};

const Navigation = (props: Props) => {
  const [currentRoute, setCurrentRoute] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location]);

  const handleNavigate = (route: string) => {
    navigate(route);
  };
  return (
    <div className='flex flex-col gap-2 pt-8'>
      {/* clinet */}
      <RoleBasedComponent allowedRoles={['admin', 'supervisor']}>
        <div
          onClick={() => handleNavigate('/collection/clients')}
          className={`flex gap-5 px-4 py-3 items-center text-sm cursor-pointer hover:bg-muted/50 transition duration-250 ease-in-out rounded-[12px] ${
            currentRoute === '/collection/clients' ||
            currentRoute.startsWith('/collection/client') ||
            currentRoute === '/collection/client/add' ||
            currentRoute === '/collection'
              ? 'font-medium text-textDark bg-muted '
              : 'text-[#848382]'
          }`}
        >
          <span className='flex items-start justify-start'>Client</span>
        </div>
      </RoleBasedComponent>

      {/* collector  */}
      <RoleBasedComponent allowedRoles={['collector']}>
        <div
          onClick={() => handleNavigate('/collection/collector')}
          className={`flex gap-5 px-4 py-3 items-center text-sm cursor-pointer hover:bg-muted/50 transition duration-250 ease-in-out rounded-[12px] ${
            currentRoute === '/collection/collector'
              ? 'font-medium text-textDark bg-muted '
              : 'text-[#848382]'
          }`}
        >
          <span className='flex items-start justify-start'>Collector</span>
        </div>
      </RoleBasedComponent>

      {/* Collection Orders */}
      <RoleBasedComponent allowedRoles={['admin', 'supervisor']}>
        <div
          onClick={() => handleNavigate('/collection/collectionorders')}
          className={`flex gap-5 px-4 py-3 items-center text-sm cursor-pointer hover:bg-muted/50 transition duration-250 ease-in-out rounded-[12px] ${
            currentRoute === '/collection/collectionorders'
              ? 'font-medium text-textDark bg-muted '
              : 'text-[#848382]'
          }`}
        >
          <span className='flex items-start justify-start'>
            Collection Orders
          </span>
        </div>
      </RoleBasedComponent>

      {/* employees */}
      <RoleBasedComponent allowedRoles={['admin']}>
        <div
          onClick={() => handleNavigate('/collection/employee')}
          className={`flex gap-5 px-4 py-3 items-center text-sm cursor-pointer hover:bg-muted/50 transition duration-250 ease-in-out rounded-[12px] ${
            currentRoute === '/collection/employee'
              ? 'font-medium text-textDark bg-muted '
              : 'text-[#848382]'
          }`}
        >
          <span className='flex items-start justify-start'>Employee</span>
        </div>
      </RoleBasedComponent>
      <RoleBasedComponent allowedRoles={['admin', 'collector', 'supervisor']}>
        <div
          onClick={() => handleNavigate('/collection/mapview')}
          className={`flex gap-5 px-4 py-3 items-center text-sm cursor-pointer hover:bg-muted/50 transition duration-250 ease-in-out rounded-[12px] ${
            currentRoute === '/collection/mapview'
              ? 'font-medium text-textDark bg-muted '
              : 'text-[#848382]'
          }`}
        >
          <span className='flex items-start justify-start'>Map view</span>
        </div>
      </RoleBasedComponent>
    </div>
  );
};

export default Navigation;
